const KEY = "admin_password";

// sessionStorage: mất khi đóng tab, đúng theo yêu cầu (không lưu dài hạn).
export function getAdminPassword(): string | null {
  return sessionStorage.getItem(KEY);
}

export function setAdminPassword(password: string): void {
  sessionStorage.setItem(KEY, password);
}

export function clearAdminPassword(): void {
  sessionStorage.removeItem(KEY);
}
